<div class="relative flex flex-col w-full" style="max-height: 90vh;">
    <div class="flex flex-row justify-between items-center">
        <div class="text-xl font-bold p-4">{{ isEdit ? 'Editar' : 'Novo' }} banco de horas</div>
        <div class="p-4">
            <button (click)="clear()" mat-icon-button type="button">
                <mat-icon class="text-secondary" [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
            </button>
        </div>
    </div>

    <div class="overflow-auto px-4 py-2">
        <form [formGroup]="form" class="grid grid-cols-1 md:grid-cols-2 gap-3">
            <mat-form-field class="w-full">
                <mat-label>Data</mat-label>
                <input matInput [matDatepicker]="entryPicker" formControlName="entry_date" placeholder="dd/mm/aaaa" />
                <mat-datepicker-toggle matSuffix [for]="entryPicker"></mat-datepicker-toggle>
                <mat-datepicker #entryPicker></mat-datepicker>
                <mat-error>Campo obrigatório</mat-error>
            </mat-form-field>
            <mat-form-field class="w-full">
                <mat-label>Tipo</mat-label>
                <mat-select formControlName="entry_type">
                    <mat-option *ngFor="let opt of entryTypeOptions" [value]="opt.value">{{ opt.label }}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field class="w-full">
                <mat-label>Horas</mat-label>
                <input
                    matInput
                    type="text"
                    formControlName="hours"
                    mask="separator.2"
                    [thousandSeparator]="'.'"
                    [decimalMarker]="','"
                    [allowNegativeNumbers]="false"
                    placeholder="0,00"
                />
                <mat-error>Campo obrigatório</mat-error>
            </mat-form-field>
            <mat-form-field class="w-full md:col-span-2">
                <mat-label>Observação</mat-label>
                <textarea matInput rows="3" formControlName="observation"></textarea>
            </mat-form-field>
        </form>

        <div class="mt-4 border-t border-gray-200 dark:border-gray-700 pt-4">
            <h4 class="text-sm font-semibold text-gray-700 dark:text-gray-200 mb-2">Anexo</h4>
            <app-module-attachments
                [module]="'USER_HOUR_BANK'"
                [entityId]="entityId"
                [loggedUser]="loggedUser"
                [typeFile]="'Documento'"
                [deferSave]="true"
                [singleFile]="true"
            ></app-module-attachments>
        </div>
    </div>

    <div class="flex justify-end gap-2 px-4 py-4 border-t border-gray-200 dark:border-gray-700">
        <button (click)="clear()" mat-stroked-button type="button" [disabled]="loading">Fechar</button>
        <button (click)="done()" mat-flat-button color="primary" type="button" [disabled]="loading || form.invalid">
            <mat-spinner *ngIf="loading" diameter="18" class="inline-block mr-2"></mat-spinner>
            Salvar
        </button>
    </div>
</div>
